import { userDraft } from './userDraft';
import { login } from './login';
import { forgetPassword } from './forgetPassword';
import { verifyCodeCheck } from './verifyCodeCheck';
import { resPartner } from './resPartner';
import { changePassword, resetPassword } from './resetPassword';
import { notifyWrite } from './notifyWrite';
import { notify } from './notify';
import { permission } from './permission';
import { repairDetail } from './repairDetail';
import { reason } from './reason';
import { repairDraft } from './repairDraft';
import { satisfaction } from './satisfaction';
import { satisfactionCheck } from './satisfactionCheck';
import { frontCategory } from './frontCategory';
import { frontVodCreate } from './frontVodCreate';
import { frontVod } from './frontVod';
import { resPartnerWrite } from './resPartnerWrite';
import { productProgress } from './productProgress';
import { repairProgress, repairProgressHistory } from './repairProgress';
import { repairStage } from './repairStage';
import { frontNewsMore } from './frontNewsMore';
import { files } from './files';
import { machineState, machineLocationList } from './machine';

export const api = {
    userDraft,
    login,
    forgetPassword,
    verifyCodeCheck,
    resPartner,
    resetPassword,
    notifyWrite,
    notify,
    permission,
    repairDetail,
    reason,
    repairDraft,
    satisfaction,
    satisfactionCheck,
    frontCategory,
    frontVodCreate,
    frontVod,
    resPartnerWrite,
    changePassword,
    productProgress,
    repairProgress,
    repairProgressHistory,
    repairStage,
    frontNewsMore,
    files,
    machineState,
    machineLocationList,
};
